import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useGetUserList } from '../api/main'
import { Button_Main } from '../components/Button'
import { Dialog } from '../components/Dialog'
import { UserCreateForm, UserUpdateForm } from '../components/Form'
import Pagenation from '../components/Pagenation'
import SearchForm, { DefaultParamKeys } from '../components/Search'
import Table from '../components/Table'
import { Main } from '../styles/layout'
import { Table_Info } from '../styles/table'

export const UserPage = () => {
  const location = useLocation()
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isUpdateOpen, setIsUpdateOpen] = useState(false)
  const [updateModalKey, setUpdateModalKey] = useState('')
  const { data, isLoading, isError } = useGetUserList(location.search)

  const openUpdateModal = (value:string) =>{
    setUpdateModalKey(value)
    setIsUpdateOpen(true)
  }
  return (
    <Main>
      <h1>사용자 관리</h1>
      <SearchForm searchList={searchList}/>
      <Table_Info>
        Total Count: {data?.total}
        <Button_Main onClick={() => setIsCreateOpen(true)}>등록</Button_Main>
      </Table_Info>
      <Table headers={headers} data={data?.data} isLoading={isLoading} isError={isError} rowKey={headers[2].value} modalKey={"loginId"} onClick={openUpdateModal}/>
      <Pagenation totalPage={data?.totalPage} isLoading={isLoading}/>

      <Dialog $isOpen={isCreateOpen} onClose={() => setIsCreateOpen(false)}>
        {isCreateOpen && <UserCreateForm onClose={() => setIsCreateOpen(false)} />}
      </Dialog>
      <Dialog $isOpen={isUpdateOpen} onClose={() => setIsUpdateOpen(false)}>
        {isUpdateOpen && <UserUpdateForm data={updateModalKey} onClose={() => setIsUpdateOpen(false)} />}
      </Dialog>
    </Main>
  )
}

const headers = [
  { value: 'partName', label: '소속' },
  { value: 'groupName', label: '그룹' },
  { value: 'loginId', label: '아이디' },
  { value: 'userName', label: '이름' },
  { value: 'createdDate', label: '등록일' },
  { value: 'updatedDate', label: '수정일' },
  { value: 'userDesc', label: '비고' }
]

const searchList:DefaultParamKeys[] = [
  'partName',
  'groupName',
  'role',
  'loginId',
  'userName'
]
